'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _elementCountConstants = require('./elementCountConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initalState = Immutable.Map();

var updateCount = function updateCount() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var modifiy = arguments[1];
    return Math.max(state + modifiy, 0);
};

/**
 * Abstract state transformer for element counts
 * @param {method} valueTransformer - method used to transform each key in the state
 * @param {string} state - current state of the reducer
 * @param {object} action - deconstruected for just { counts }; a map of elementCounts used to modifiy the existing state
 * @return {object} transformed state
 *
 * @example
 * // results in { CARD: 3, BOARD: 4 }
 * const stateTransform = (state = 0, modifiy) => state + modifiy;
 * transformCount(stateTransform)({ CARD: 2, BOARD: 1 }, { CARD: 1, BOARD: 3 })
 * @example
 */
var transformCount = function transformCount(valueTransformer) {
    return function (state, _ref) {
        var counts = _ref.counts;
        return state.withMutations(function (mutateState) {
            var elementTypes = (0, _lodash.keys)(counts);
            elementTypes.forEach(function (type) {
                mutateState.set(type, valueTransformer(mutateState.get(type, 0), counts[type]));
            });
        });
    };
};

var increaseElementCount = transformCount(updateCount);
var decreaseElementCount = transformCount(function (a, b) {
    return updateCount(a, b * -1);
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
    var action = arguments[1];

    switch (action.type) {
        case _elementCountConstants.ELEMENT_COUNT_INCREAESE:
            return increaseElementCount(state, action);
        case _elementCountConstants.ELEMENT_COUNT_DECREASE:
            return decreaseElementCount(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/elementCount/elementCountReducer.js
// module id = 2110
// module chunks = 0